var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"list-none flex flex-col items-center justify-center min-w-fit"},[(_vm.withDivider)?_c('Divider'):_vm._e(),_vm._v(" "),_c('div',{staticClass:"w-full text-center label-lg"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }